module.exports = __webpack_public_path__ + "img/internship-challenge-illustration.648b4dad.png";